import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";

import { TableCell, ModalRef } from "@shared/components";
import { Discount } from "@shared/types";

export const useCodeListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  codeModalRef: RefObject<ModalRef>,
  discounts?: Discount[],
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "discount",
        headerName: translate("limited_code_admin.fields.discount"),
        minWidth: 300,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/discounts/edit/${value}`}
            value={discounts?.find(discount => discount.id === value)?.name}
          />
        ),
      },
      {
        field: "code",
        headerName: translate("limited_code_admin.fields.code"),
        minWidth: 150,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "used",
        headerName: translate("limited_code_admin.fields.used"),
        minWidth: 100,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Container align="center">
            {value ? <DoneIcon /> : <CloseIcon />}
          </TableCell.Container>
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => codeModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, codeModalRef, discounts],
  );
};
